import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { FormControl, FormHelperText, TextField } from '@mui/material';
const CustomDatePicker = ({ label, date, error, helperText, handleDateChange, onValidate }) => {
    return (_jsxs(FormControl, Object.assign({ component: "fieldset", error: error }, { children: [_jsx(LocalizationProvider, Object.assign({ dateAdapter: AdapterMoment }, { children: _jsx(DatePicker, { label: label, value: date, onChange: (newValue) => {
                        handleDateChange(newValue);
                    }, renderInput: (params) => _jsx(TextField, Object.assign({}, params)) }) })), _jsx(FormHelperText, { children: helperText })] })));
};
export default CustomDatePicker;
//# sourceMappingURL=index.js.map